import { Injectable } from '@angular/core';
import { QueryResults } from '@mode/shared/data-access-algolia';
import { ColumnsInfo, PinnedTable, SchemaListUpdate, Table, TablesUpdate } from '@mode/shared/contract-common';
import { iconClassFromColumnType } from '@mode/shared/util-js';
import algolia from 'algoliasearch';
import { AlphabeticalSchemasFacade } from './alphabetical-schemas-facade.interface';
import { MAX_DATASOURCE_TABLES } from './constants';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { SearchClientService } from '@mode/algolia/domain';

@Injectable()
export class AlgoliaSchemasFacade implements AlphabeticalSchemasFacade {
  constructor(private _searchClientService: SearchClientService) {}

  public getSchemaListUpdate(currentPage: number, dataSourceToken: string): Promise<SchemaListUpdate> {
    throw new Error('Can no longer use Algolia for fetching schemas');
  }

  public getPageOfTables(page: number, dataSourceToken: string, schemaName: string): Promise<TablesUpdate> {
    throw new Error('Can no longer use Algolia for fetching tables');
  }

  public getFirstPageOfTables(dataSourceToken: string, schemaName: string): Promise<TablesUpdate> {
    throw new Error('Can no longer use Algolia for fetching tables');
  }

  public getTablePreview(dataSourceToken: string, table: Partial<Table>): Promise<ColumnsInfo> {
    const preview: ColumnsInfo = {
      columns:
        table.columns != null
          ? table.columns.map((column: any) => {
              if (typeof column === 'string') {
                column = { name: column };
              }
              column.type = column.type || column.dataType;
              column.typeClass = iconClassFromColumnType(column.type);
              return column;
            })
          : [],
    };
    return Promise.resolve(preview);
  }

  parseFullNameIntoSchemaAndName(fullName: string): { schema: string; name: string } {
    const [schema, name] = fullName.split('/');
    return { schema, name };
  }

  convertTableToPinId(dataSourceToken: string, table: Partial<Table & PinnedTable>) {
    return table.id || table.objectID || '';
  }

  parseIdIntoObjectID(id: string) {
    return id;
  }
}
